export const blogData=[

]
export const services=[
    {
        title:"Teaching & Training",
        subtitle:"We also launched the Mary Antoinette Brown Sherman Think Tank, which will strengthen the position of girls & women.",
        image_url:"images/home/tttc.jpg",
        icon:'images/home/school.svg',
        link:"teachingandtraining"
    },
    {
        title:"Research",
        subtitle:"At KAICT we pride ourselves with being the main research institute on peace studies and conflict transformation in Liberia. KAICT’s research – on peace, conflict, security, development and gender – focuses on key issues affecting Liberia today. Our research is locally driven and implemented in collaboration with national and international partners. It adopts interdisciplinary approaches, is based on fieldwork and practice-based. It provides local knowledge and understanding of socio-political, socio-economic and socio-cultural dynamics in Liberia and offers local solutions. ",
        image_url:"images/home/research.jpg",
        icon:'images/home/lab_research.svg',
        link:"research"
    },
    {
        title:"Outreach Programs",
        subtitle:"We also launched the Mary Antoinette Brown Sherman Think Tank, which will strengthen the position of girls & women.",
        image_url:"images/home/offer-2.png",
        icon:'images/home/group.svg',
        link:"outreachprograms"

    },
    {
        title:"Policy Engagement",
        subtitle:"We also launched the Mary Antoinette Brown Sherman Think Tank, which will strengthen the position of girls & women.",
        image_url:"images/home/offer-1.png",
        icon:'images/home/policy-1.svg',
        link:"policyEngagement"
    },

]

export const researchProjects =[
    {
        title:" Hope for a better Future: Building Collaborative Resilience for Youth in Liberia",
        subtitle:"  We also launched the Mary Antoinette Brown Sherman Think Tank, which will strengthen the position of girls and women in society through leadership and governance training programs, by providing a platform for discussion and through research.",
        image_url:"images/home/Monument.png"
    },
    {
        title:" Hope for a better Future: Building Collaborative Resilience for Youth in Liberia",
        subtitle:"  We also launched the Mary Antoinette Brown Sherman Think Tank, which will strengthen the position of girls and women in society through leadership and governance training programs, by providing a platform for discussion and through research.",
        image_url:"images/home/Monument.png"
    }

]